import AboutSection from './components/AboutSection';
import CtaSection from './components/CtaSection';
import DiferenciaisSection from './components/DiferenciaisSection';
import FooterSection from './components/FooterSection';
import HeroSection from './components/HeroSection';
import Navbar from './components/Navbar';
import ServicesSection from './components/ServicesSection';

const WA = 'https://wa.me/5555996946460?text=Olá,%20vim%20pelo%20Google%20e%20quero%20agendar%20consulta';

export default function Home() {
  return (
    <div className="min-h-screen bg-[#F5F5F0]">
      <Navbar />
      <main>
        <HeroSection />
        <AboutSection />
        <ServicesSection />
        <DiferenciaisSection />
        <CtaSection />
      </main>
      <FooterSection />
      {/* WhatsApp flutuante */}
      <a
        href={WA}
        target="_blank"
        rel="noopener noreferrer"
        onClick={(e) => {
          e.preventDefault();

          if (typeof gtag_report_conversion === 'function') {
            gtag_report_conversion(WA);
          } else {
            window.open(WA, '_blank');
          }
        }}
        className="fixed bottom-6 right-6 w-14 h-14 bg-[#25D366] rounded-full flex items-center justify-center shadow-2xl hover:scale-110 transition-transform duration-300 cursor-pointer z-50"
        aria-label="WhatsApp"
      >
        <i className="ri-whatsapp-line text-2xl text-white"></i>
      </a>
    </div >
  );
}